var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('SiteBaseNav'),_c('FadeTransition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view'),_vm._t("default")],2),_c('div',{staticClass:"mt-5 mb-5 w-100",staticStyle:{"color":"transparent"}},[_vm._v(".")]),(_vm.hasCustomFooter)?_c('CustomFooter'):_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }